import { Injectable } from '@angular/core';
import { FiNotificationService } from '../notification.service';
import { FiBrowserCheckNotificationComponent } from './browser-check-notification.component';

@Injectable()
export class FiBrowserCheckService {
    constructor(private notificationService: FiNotificationService) {}

    checkCurrentBrowser() {
        if (!this.checkBrowserUserAgent(navigator.userAgent)) {
            return this.notificationService.AddNotification(FiBrowserCheckNotificationComponent);
        }
    }

    checkBrowserUserAgent(userAgent) {
        return (
            userAgent.match(/^((?!edge).)*$/i) &&
            userAgent.match(/^Mozilla\/5.0 \(.+\) AppleWebKit\/.+ \(.+\) (Chrome|Version)\/.+ Safari\/.+$/i) &&
            // chrome on MacOS is not allowed
            !userAgent.match(/^Mozilla\/5.0 \(Macintosh.+\) AppleWebKit\/.+ \(.+\) Chrome\/.+ Safari\/.+$/i)
        );
    }

    isMobile(): boolean {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }

    isIOS(): boolean {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    isAndroid(): boolean {
        return /Android/i.test(navigator.userAgent);
    }
}
